import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { Box } from '@mui/material';

// eslint-disable-next-line react/prop-types
const DatePickerCustomInput = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    value,
    onClick,
    className,
    inputContainerStyle,
    allText = 'All'
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Box, {
    className: className,
    ref: ref,
    sx: _objectSpread2({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '8px 12px',
      paddingRight: '6px',
      border: '1px solid #e6e6e6',
      borderRadius: '4px',
      cursor: 'pointer',
      width: '100%',
      backgroundColor: '#fff',
      height: '32px',
      minWidth: '200px'
    }, inputContainerStyle),
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      maxWidth: '90%'
    }
  }, /*#__PURE__*/React__default.createElement("i", {
    className: "meta-crm-icon-ic_calendar font-size-20",
    style: {
      marginRight: '8px'
    }
  }), /*#__PURE__*/React__default.createElement(Box, {
    component: "span",
    sx: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: '14px',
      color: '#000'
    }
  }, value || allText)), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      padding: '2px',
      ':hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
        borderRadius: '50%'
      }
    }
  }, /*#__PURE__*/React__default.createElement("i", {
    className: "meta-crm-icon-ic_arrow-down font-size-20"
  })));
});
var DatePickerCustomInput$1 = DatePickerCustomInput;
export { DatePickerCustomInput$1 as default };